module.exports = "<div id=\"container\">\n    <div id=\"profile-card\">\n        <div id=\"profile-name\">\n            Hayden Sookchand\n        </div>\n        <a routerLink=\"/profile\">\n            <div id=\"profile-pic\"></div>\n        </a>\n    </div>\n    <div id=\"app\">\n        <router-outlet></router-outlet>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main